module.exports = __webpack_public_path__ + "images/sprites/ui/btn_car_cv_bu_71096efcfee5d3fd3ea7c5e163fe2e6e.png";